import Swal from "sweetalert2";

export const validateForm = (formData, translations) => {
  const { title, paymentMethod, amount, description, category, entryType } = formData;

  const errors = [];

  if (!title) errors.push("Title is required");
  if (!paymentMethod) errors.push("Payment Method is required");
  if (!amount && amount !== 0) errors.push("Amount is required");
  if (!description) errors.push("Description is required");
  if (!category) errors.push("Category is required");
  if (!entryType) errors.push("Entry Type is required");

  if (errors.length > 0) {
    Swal.fire({
      title: translations.error || "Error",
      text: errors.join(", "),
      icon: "error",
      confirmButtonText: translations.ok || "Ok",
    });
    return false;
  }

  return true;
};